import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipePipesizeCreate from './QaqcPipePipesizeCreate';
import type { QaqcPipePipesize } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';

const QaqcPipePipesizeView: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipePipesize } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipePipesize | undefined>(state?.record);

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_pipesize', 'id', id);
        const row = Array.isArray((res as any)?.data) ? (res as any).data[0] : (Array.isArray(res) ? (res as any)[0] : undefined);
        if (row) setRecord(row as QaqcPipePipesize);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate('/qaqc/piping/tools/pipesizes');

  return (
    <QaqcPipePipesizeCreate
      mode="edit"
      initialValues={record}
      onBack={goBack}
      viewOnly
    />
  );
};

export default QaqcPipePipesizeView;
